import { useMutation } from '@tanstack/react-query';
import type { Color } from '../types/CandidateBoard';

type Request = {
  id: number;
  title: string;
  divide_status: string;
  order_number: number;
  color_type: Color;
};

export default function useUpdateCandidateBoard() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async ({ id, title, divide_status, order_number, color_type }: Request) => {
      const response = await fetch(`/agent/api/candidate_boards/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify({
          title,
          divide_status,
          order_number,
          color_type,
        }),
      });
      const data = await response.json();
      return data;
    },
  });
}
